type ModalActionsProps = {
  justify?: 'right' | 'center';
  children: React.ReactNode;
};

export default function ModalActions({ justify, children }: ModalActionsProps) {
  return (
    <div
      className={`absolute bottom-[40px] right-[28px] flex mt-[32px] ${justifyClassName(
        justify,
      )} mobile:static`}
    >
      {children}
    </div>
  );
}

const justifyClassName = (justify?: string) => {
  switch (justify) {
    case 'right':
      return 'justify-end';
    case 'center':
      return 'justify-center';
    default:
      return 'justify-start';
  }
};
